<template>
  <div>
    <div class="con" v-loading="loading">
      <div class="text item">
        <div class="Table-Con">
          <el-form ref="ruleForm" label-width="250px" class="demo-ruleForm">
            <el-form-item :label="`${$t('lang.ConfigSetting.Enable')}：`" prop="name">
                <el-checkbox v-model="data.enabled"/>
            </el-form-item>
            <el-form-item :label="`${$t('lang.ConfigSetting.Address')}：`" prop="name">
                <el-input size="mini" class="Form-Input-Width" v-model="data.weburl"/>
            </el-form-item>
            <el-form-item :label="`${$t('lang.ConfigSetting.PageUpdate')}：`" prop="name">
                <el-checkbox v-model="data.webrefresh"/>
            </el-form-item>
            <el-form-item :label="`${$t('lang.ConfigSetting.JumpAddressAfterAuthentication')}：`" prop="name">
                <el-input size="mini" class="Form-Input-Width" v-model="data.redirecturl"/>
            </el-form-item>
            <el-form-item :label="`${$t('lang.ConfigSetting.SessionTimeout')}：`" prop="name">
                <el-input size="mini" class="Form-Input-Width" v-model="data.sessiontimeout"/>
            </el-form-item>
            <el-form-item :label="`${$t('lang.ConfigSetting.MaximumNumberOfCustomers')}：`" prop="name">
                <el-input size="mini" class="Form-Input-Width" v-model="data.maxclients"/>
            </el-form-item>
            <el-form-item :label="`${$t('lang.ConfigSetting.UncertifiedEquipment')}：`" prop="name">
                <arr-add-input :list="data.preauthenticated_users" @GetArrList="GetPreauthenticatedUsers"/>
            </el-form-item>
            <el-form-item :label="`${$t('lang.ConfigSetting.CertifiedEquipment')}：`" prop="name">
                <arr-add-input :list="data.authenticated_users" @GetArrList="GetAuthenticatedUsers"/>
            </el-form-item>
            <el-form-item :label="`${$t('lang.ConfigSetting.AuthenticationFreeMACAddress')}：`" prop="name">
                <arr-add-input  :list="data.trustedmac" @GetArrList="GetTrustedMac"/>
            </el-form-item>
            <el-form-item :label="`${$t('lang.ConfigSetting.IgnoreWiredDevices')}：`" prop="name">
                <el-checkbox v-model="data.nowired"/>
            </el-form-item>
            <el-form-item :label="`${$t('lang.ConfigSetting.debug')}：`" prop="name">
              <el-select v-model="data.debuglevel" :placeholder="`${$t('lang.ConfigSetting.pleaseChoose')}：`" size="mini" class="Form-Input-Width">
                <el-option
                  v-for="item in DebuggingList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <el-button type="danger" size="mini" class="Config-Buttom"
      @click="updateConfig">
        {{$t('lang.ConfigSetting.SaveApply')}}
      </el-button>
    </div>
  </div>
</template>

<script>
import ArrAddInput from '../ArrAddInput'
import { updateConfig, listConfig } from "@/api/configurationlist";
import { cloneDeep, isEqual } from 'lodash'
export default {
  name: "PortalAuthentication",
  props: ["deviceDid", "deviceSn"],
  data(){
      return{
          loading:true,
          DebuggingList:[
              {value:'0',label:this.$t('lang.ConfigSetting.not')},
              {value:'1',label:this.$t('lang.ConfigSetting.error')},
              {value:'2',label:this.$t('lang.ConfigSetting.information')},
              {value:'3',label:this.$t('lang.ConfigSetting.debug')}
          ],
          data: {},
          WatchData: {}
      }
  },
  watch: {
    deviceSn: {
      immediate: true,
      handler(newValue, oldValue) {
        this.getConfig()
      },
    }
  },
  components:{
      ArrAddInput
  },
  methods:{
    // 获取配置参数
    getConfig() {
      this.loading = true
      listConfig(this.deviceSn, this.deviceDid, [
        {
          section: "nodogsplash",
          config: "nodogsplash",
          options: [
            { option: "enabled" },
            { option: "weburl" },
            { option: "webrefresh" },
            { option: "redirecturl" },
            { option: "sessiontimeout" },
            { option: "maxclients" },
            { option: "debuglevel" },
            { option: "nowired" }
          ],
          lists:[
            { list:'preauthenticated_users' },
            { list:'authenticated_users' },
            { list:'trustedmac' }
          ]
        }
      ]).then(res => {
        this.data = {
          ...res.data.data.mess[0].s_objects[0].options,
          ...res.data.data.mess[0].s_objects[0].lists
        }
        //设备复选框值转换成布尔值
        this.data.enabled=this.data.enabled=='1'?true:false
        this.data.webrefresh=this.data.webrefresh=='1'?true:false
        this.data.nowired=this.data.nowired=='1'?true:false
        this.WatchData = cloneDeep(this.data)
        this.loading = false
      }).catch(err => {
        this.$message({
          message: this.$t('lang.request.timeout'),
          type: "warning"
        })
      })
    },
    //获取未认证设备
    GetPreauthenticatedUsers(props){
        this.data.preauthenticated_users=props
    },
    //获取已认证设备
    GetAuthenticatedUsers(props){
        this.data.authenticated_users=props
    },
    //获取免认证设备MAC地址
    GetTrustedMac(props){
        this.data.trustedmac=props
    },
    //保存配置
    updateConfig(){
      if(!isEqual(this.data, this.WatchData)) {
        //保存配置时转换
        const data=Object.assign({},this.data)
        delete this.data.preauthenticated_users
        delete this.data.authenticated_users
        delete this.data.trustedmac
        this.data.enabled=this.data.enabled?'1':''
        this.data.webrefresh=this.data.webrefresh?'1':''
        this.data.nowired=this.data.nowired?'1':''
        updateConfig(this.deviceSn, this.deviceDid,[
          {
            section: "nodogsplash",
            config: "nodogsplash",
            action: 0,
            index: [0],
            server:'nodogsplash',
            options: {
                ...this.data
            },
            lists:{
                preauthenticated_users:data.preauthenticated_users,
                authenticated_users:data.authenticated_users,
                trustedmac:data.trustedmac
            }
          }
        ]).then(res => {
            if (res.data.data.mess === 0) {
                this.$message({
                    showClose: true,
                    message: this.$t('lang.ConfigSetting.Successfulconfiguration'),
                    type: "success"
                });
                this.getConfig()
            } else {
                this.$message({
                    showClose: true,
                    message: this.$t('lang.ConfigSetting.Configurationerror'),
                    type: "warning"
                });
                return;
            }
        }).catch((err)=>{
          
        })
      }else{
        this.$message({
          showClose: true,
          message: this.$t('lang.ConfigSetting.Nochangesmade'),
          type: 'warning'
        });
        return
      } 
    }
  }
}
</script>
<style src='../common.css' scoped></style>
